import PropTypes from 'prop-types';
import cx from 'classnames';
import withTheme from 'core/hocs/withTheme';
import Avatar from 'core/components/Avatar';
import Link from 'core/components/Link';

import { resolveScopedStyles } from 'core/utils/styled-jsx';
import themePropTypes from 'core/utils/prop-types/theme';
import modelPropTypes, { personAttributes } from 'core/utils/prop-types/model';

import styles from './index.styl';

function Expert({ content, theme }, { mediaUrlPrefix }) {
  if (!content) {
    return false;
  }
  const expertTheme = theme.controls.expert;
  const {
    avatar,
    name,
    slug,
    job_title: jobTitle,
  } = content.attributes;
  const userAvatar = avatar && avatar.attributes.versions.original;

  const scope = resolveScopedStyles(
    <scope>
      <style jsx>{`
        .link
          text-decoration none
          &:visited
          &:hover
          &:active
            text-decoration none
          &:hover
            :global(.authorName)
              font ${expertTheme.name.hover.font}
              color ${expertTheme.name.hover.color}
              border-bottom ${expertTheme.name.hover.borderBottom}
              text-transform ${expertTheme.name.hover.textTransform}
              margin ${expertTheme.name.hover.margin}
      `}</style>
    </scope>
  );

  return (
    <Link
      to={`${mediaUrlPrefix || ''}/authors/${slug}`}
      className={scope.wrapClassNames('link')}
    >
      <div className={cx(styles.expert, !jobTitle && styles.withoutJobTitle)}>
        <style jsx>{`
          .${styles.expert}
            flex-direction ${expertTheme.wrapper.flexDirection}
            align-items ${expertTheme.wrapper.alignItems}
          .${styles.authorInfo}
            margin-left ${expertTheme.info.marginLeft}
            align-items ${expertTheme.info.alignItems}
          .authorName
            font ${expertTheme.name.idle.font}
            color ${expertTheme.name.idle.color}
            border-bottom ${expertTheme.name.idle.borderBottom}
            text-transform ${expertTheme.name.idle.textTransform}
            margin ${expertTheme.name.idle.margin}
          .jobTitle
            color ${expertTheme.jobTitle.color}
            font ${expertTheme.jobTitle.font}
          .${styles.avatar}
            border-radius ${expertTheme.avatar.borderRadius}
            &:after
              color ${expertTheme.label.color}
              font ${expertTheme.label.font}
              background ${expertTheme.label.background}
              text-transform ${expertTheme.label.textTransform}
              letter-spacing ${expertTheme.label.letterSpacing}
              border-radius ${expertTheme.label.borderRadius}
        `}</style>
        <div className={styles.avatar}>
          <Avatar
            isCircular={expertTheme.avatar.isAvatarCircular}
            src={userAvatar}
            size={expertTheme.avatar.width}
          />
        </div>
        <div className={cx(styles.authorInfo, 'authorInfo')}>
          <div className='authorName'>{name}</div>
          <div className='jobTitle'>
            {jobTitle}
          </div>
        </div>
      </div>
      <scope.styles />
    </Link>
  );
}

const nameContract = '{ font, borderBottom, textTransform, margin, color }';
const contract = `{
  wrapper: {
    flexDirection,
    alignItems
  },
  info : {
    alignItems,
    marginLeft
  },
  name: {
    idle: ${nameContract},
    hover: ${nameContract},
  },
  jobTitle: {
    color,
    font
  },
  label: {
    background,
    color,
    font,
    textTransform,
    letterSpacing,
    borderRadius
  },
  avatar: {
    borderRadius,
    isAvatarCircular,
    width
  }
}`;

Expert.propTypes = {
  /**
   * Атрибуты пользователя, берутся из API
   */
  content: modelPropTypes(personAttributes),
  /**
   * Префикс пути для проектов с раздельной сервисной/медийной частями
   */
  mediaUrlPrefix: PropTypes.string,
  /** @ignore */
  theme: themePropTypes(`{
    controls: {
      expert: {
        ${contract}
      }
    }
  }`),
};

Expert.contextTypes = {
  mediaUrlPrefix: PropTypes.string,
};

const ExpertWithHOCs = withTheme(Expert);
ExpertWithHOCs.displayName = 'Expert';

export { Expert as StorybookComponent };
export default ExpertWithHOCs;
